import React from 'react';
import { Box, IconButton, Stack /* Toolbar */ } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
// import PersonAddIcon from '@mui/icons-material/PersonAdd';

import AppLogo from '../../../../../components/AppLogo';
import DashboardBarButton from './DashboardBarButton';
import ParticipantsButton from './ParticipantsButton';
import FullScreenButton from './FullScreenButton';
import AdminTools from './AdminTools';
import { COLORS } from '../../../../../constants/colors';

import MytaverseAppBar from '../../../../../components/MytaverseAppBar';

import { EventDrawerTabs } from '../../../constants';

import { IDashboardTopBarContentView } from './interfaces';

import { useStyles } from './styles';
import { useMytaverse } from '../../../../../providers/MytaverseProvider';
import { useMytaverseEvent } from '../../../providers';

import UserAvatarButton from '../../../../../components/UserAvatarButton';
import { env } from '../../../../../env';
import { IXRHrPersonaTypes } from '../../../../../interfaces/profile';
import { EventRole } from '../../../../../interfaces/event';

const {
  REACT_APP_SHOW_LEFT_BAR,
  REACT_APP_SHOW_PROFILE,
  REACT_APP_SHOW_ADMIN_TOOLS,
} = env;

const DashboardTopBarContentView = ({
  currentRoom,
  isOpenChat,
  hasMediaStream,
  showInviteUserBtn,
  participantTotal,
  onOpenEventDrawer,
  onOpenConfirmLogoutModal,
  // onOpenInviteUserModal,
  currentEvent,
}: IDashboardTopBarContentView) => {
  const classes = useStyles({
    isOpenChat,
    hasMediaStream,
  });

  const { user } = useMytaverse();
  const { currentParticipant } = useMytaverseEvent();
  const showLeftMenu = currentEvent?.enablePureGamecast || currentRoom;
  const showAdminTools = REACT_APP_SHOW_ADMIN_TOOLS === 'true';

  const isCurrentParticipantAdmin =
    showAdminTools &&
    (currentParticipant?.eventRole === EventRole.Admin ||
      user?.hrData?.persona?.toUpperCase() ===
        IXRHrPersonaTypes.HR_Facilitator);

  const showLeftBar = REACT_APP_SHOW_LEFT_BAR === 'true';
  const showProfile = REACT_APP_SHOW_PROFILE === 'true';

  return (
    <>
      {showLeftBar ? (
        <MytaverseAppBar sx={classes.leftBar}>
          <Stack sx={classes.stack} direction="row">
            {showLeftMenu ? (
              <>
                <Box sx={classes.root} component="div">
                  <DashboardBarButton
                    buttonIcon={<LocationOnIcon />}
                    onClick={() => onOpenEventDrawer(EventDrawerTabs.Locations)}
                  >
                    {currentRoom?.name || 'Lobby'}
                  </DashboardBarButton>
                  <ParticipantsButton
                    onClick={() =>
                      onOpenEventDrawer(EventDrawerTabs.Participants)
                    }
                    total={participantTotal}
                  />
                </Box>
                <IconButton
                  sx={classes.iconButton}
                  onClick={() => onOpenEventDrawer(EventDrawerTabs.Locations)}
                >
                  <MenuIcon />
                </IconButton>
              </>
            ) : (
              <Box sx={classes.rootLoading}>
                <Stack flexDirection="row" alignItems="center">
                  {window.location.hostname.includes('troovrs') ? null : (
                    <AppLogo color={COLORS.WHITE} />
                  )}
                </Stack>
              </Box>
            )}
          </Stack>
        </MytaverseAppBar>
      ) : null}

      <MytaverseAppBar sx={classes.rightBar}>
        <Stack sx={classes.stack} direction="row">
          <FullScreenButton />
          {/*{showInviteUserBtn ? (*/}
          {/*  <DashboardBarButton*/}
          {/*    onClick={onOpenInviteUserModal}*/}
          {/*    buttonIcon={<PersonAddIcon sx={classes.addPersonIcon} />}*/}
          {/*    sx={classes.inviteUserBtn}*/}
          {/*  />*/}
          {/*) : null}*/}
          {isCurrentParticipantAdmin ? <AdminTools /> : null}
          {showProfile ? <UserAvatarButton /> : null}
          <DashboardBarButton
            onClick={onOpenConfirmLogoutModal}
            buttonIcon={<LogoutIcon sx={classes.logoutIcon} />}
          />
        </Stack>
      </MytaverseAppBar>
    </>
  );
};

export default DashboardTopBarContentView;
